import { render, staticRenderFns } from "./pdaHeader.vue?vue&type=template&id=3bd0af62&"
import script from "./pdaHeader.vue?vue&type=script&lang=js&"
export * from "./pdaHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports